import {
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { UserDetailsContext } from "../../HardwareDetails/HardwareDetails";
import { generateRequestTicket } from "../../../helper/generateTicket";
import { createZendeskTicket } from "../../../resource/bff";
import { ActionsModal } from "../ActionsModal";
import { ActionStatusContext } from "../Actions";

export default function RequestModal(props) {
  const requestType = props.isHardware ? "Hardware" : "Accessory";
  const userDetails = useContext(UserDetailsContext);
  const { setIsLoading, showActionResponse, setIsActionSuccess } =
    useContext(ActionStatusContext);
  const [isRequestForProject, setIsRequestForProject] = useState("");
  const [itemRequested, setItemRequested] = useState("");
  const [additionalInfo, setAdditionalInfo] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    props.onClose();
    setIsLoading(true);
    const ticket = generateRequestTicket(
      userDetails.workingOffice.country,
      userDetails.homeOffice.name,
      userDetails.homeOffice.country,
      userDetails.employeeNumber,
      itemRequested,
      isRequestForProject,
      additionalInfo,
      requestType
    );
    try {
      await createZendeskTicket(ticket);
      setIsActionSuccess(true);
    } catch (error: any) {
      setIsActionSuccess(false);
    } finally {
      setItemRequested("");
      setAdditionalInfo("");
      setIsRequestForProject("");
    }
    setIsLoading(false);
    showActionResponse();
  };

  return (
    <ActionsModal
      isOpen={props.isOpen}
      onClose={props.onClose}
      heading={"Request"}
      title={requestType}
      isFormValid={itemRequested != "" && isRequestForProject != ""}
      onSubmit={onSubmit}
    >
      <FormControl
        variant="standard"
        sx={{ minWidth: 400, marginBottom: "25px" }}
      >
        <InputLabel id={"specify-item-label"}>
          <Typography display={"inline"}>
            Specify {requestType.toLowerCase()} name
          </Typography>
          <Typography display={"inline"} color={"red"}>
            *
          </Typography>
        </InputLabel>
        <Input
          multiline
          maxRows={5}
          aria-labelledby={"specify-item-label"}
          value={itemRequested}
          onChange={(e) => setItemRequested(e.target.value)}
        />
      </FormControl>
      <FormControl
        variant="standard"
        sx={{ minWidth: 400, marginBottom: "25px" }}
      >
        <InputLabel id={"is-request-for-project"}>
          <Typography display={"inline"}>Is it for a project</Typography>
          <Typography display={"inline"} color={"red"}>
            *
          </Typography>
        </InputLabel>
        <Select
          labelId={"is-request-for-project"}
          onChange={(e: SelectChangeEvent) => {
            setIsRequestForProject(e.target.value);
          }}
          value={isRequestForProject}
        >
          <MenuItem key="yes" value="Yes">
            Yes
          </MenuItem>
          <MenuItem key="no" value="No">
            No
          </MenuItem>
        </Select>
      </FormControl>
      <FormControl
        variant="standard"
        sx={{ minWidth: 400, marginBottom: "32px" }}
      >
        <InputLabel id={"additional-information-label"}>
          <Typography display={"inline"}>Additional Information</Typography>
        </InputLabel>
        <Input
          multiline
          maxRows={5}
          aria-labelledby={"additional-information-label"}
          value={additionalInfo}
          onChange={(e) => setAdditionalInfo(e.target.value)}
        />
      </FormControl>
    </ActionsModal>
  );
}
